// What a HYDROS controller logs that TankSensei does not read, and the ORP
// card offer. Feedback #72 (2026-10-12): "more inputs than just pH,
// salinity and temperature ... including manual inputs configured in the
// hydros." CoralVue documents a unit for six log types only; a manual test
// comes "as recorded", so it is named here, never read with a guessed unit.

import { historyCardPatch } from '../../shared/tank-purpose.js';

const SHOWN = 6;

// The tank panel's line, or null when there is nothing to say.
export function unreadLine(unread) {
  const list = (Array.isArray(unread) ? unread : []).filter((u) => u?.name);
  if (!list.length) return null;
  const names = list.map((u) => u.name);
  const shown =
    names.length > SHOWN
      ? `${names.slice(0, SHOWN).join(', ')} and ${names.length - SHOWN} more`
      : names.join(', ');
  const line = `Also logged by this controller, not read by TankSensei: ${shown}.`;
  // Flow comes in L/h. The rest come "as recorded": a manual test, or a
  // sensor input whose meaning is the keeper's wiring, so the copy says
  // what is known and never names what a series is.
  const unitless = list.filter((u) => u.kind !== 'flow').map((u) => u.name);
  if (!unitless.length) return line;
  const what =
    unitless.length === list.length ? (list.length === 1 ? 'it' : 'these') : nameList(unitless);
  return `${line} HYDROS sends ${what} without a unit, and TankSensei does not guess one. If ${
    unitless.length === 1 ? 'it' : 'one'
  } is a test you do by hand, log the result in TankSensei too, from Home or Log.`;
}

function nameList(names) {
  if (names.length > SHOWN)
    return `${names.slice(0, SHOWN).join(', ')} and ${names.length - SHOWN} more`;
  if (names.length === 1) return names[0];
  return `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;
}

// The card patch for "Show ORP on Home", or null: only when the controller
// gives this tank ORP and no ORP card shows. Never on an empty params blob,
// where one saved card would replace the starting cards it falls back to.
export function orpCardOffer(tank, values) {
  const params = tank?.params;
  if (!params || typeof params !== 'object' || !Object.keys(params).length) return null;
  if (!(Array.isArray(values) ? values : []).some((v) => v?.key === 'orp')) return null;
  const patch = historyCardPatch(params, 'orp');
  return Object.keys(patch).length ? patch : null;
}

// Home's Today line for a key-connected controller on no tank.
export function unlinkedControllerRow(c) {
  return {
    title: `${c.name} (HYDROS) is not linked to a tank`,
    text: 'Its readings go nowhere until it is. Tap to link it, add a tank for it, or remove its key if no tank needs it.',
  };
}
